




















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import VueGallery from 'vue-gallery';
import { APP_CONFIG } from '@/config/app-config';
import { FileType } from '@/models/file-type';
import { PayServiceModel } from '@/models/payservice';
import formatNumber from '@/shared/filters/format-number';
import utility from '@/utility/utility';
@Component({
    components: {
        'gallery': VueGallery
    }
})
export default class AmountDetailPayService extends Vue {
    @Prop({ default: null })
    private payservice!: PayServiceModel;
    @Prop({ default: [] as FileType[]})
    private listImages = [] as FileType[];
    private index = null;
    get imgs() {
        return this.listImages.map(x => { return x.src; });
    }
    onChangeFile(event: any) {
        const onLoad = (file: any, id: number) => {
            const reader = new FileReader();
            reader.onload = e => {
                const arrFileType = file.name.split('.');
                this.listImages.push({
                    fileName: `${utility.randomString(35)}.${arrFileType[arrFileType.length - 1]}` ,
                    src: reader.result || undefined,
                    file,
                    id
                });
            };
            reader.readAsDataURL(file);
        }

        if (event.target.files && event.target.files[0]) {
            let i = 1;
            const files = event.target.files;
            for (const file of files) {
                onLoad(file, i);
                i++;
            }
        }
    }

    onDeleteImage(id: number) {
        this.listImages = this.listImages.filter(x => x.id !== id);
        (this.$refs.fileInput as any).value = null;
    }
    
    showGallery(index: any) {
        this.index = index;
    }
}
